/*
 * @todo Deprecate -- use `UserModule` instead.
 */

import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const AuthorModule = {
  namespaced: true,

  state: {
    author: {
      active: true
    },
    authors: []
  },

  actions: {
    async getAuthors ({ commit, state }) {
      commit('LoaderModule/setLoaders', {
        'gettingAuthor': true
      }, { root: true })

      await PaApi().get(
        `/admin/authors?page[size]=500`
      ).then((resp) => {
        commit('storeAuthors', resp)
        commit('sortAuthors')
      }).finally(() => {
        commit('LoaderModule/setLoaders', {
          'gettingAuthor': false
        }, { root: true })
      })
    },

    sortAuthors ({ commit, state }) {
      commit('sortAuthors')
    }
  },

  mutations: {
    sortAuthors (state, authors = undefined) {
      authors = authors || state.authors
      // Sort authors by last name.
      authors.sort(function (a, b) {
        const nameA = a.sort_name.toUpperCase()
        const nameB = b.sort_name.toUpperCase()

        if (nameA < nameB) {
          return -1
        }

        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
    },

    storeAuthors (state, payload) {
      baseOpts.recursive = true
      state.authors = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/AuthorModule.js